import throttle from 'lodash/throttle';

class Header {
    constructor(elem) {
        this.elem = elem;
        this.breakpoints = {
            'navigation-breakpoint': 1111,
        };
        this.belowBreakpoint = true;
    }

    init() {
        this.initBodyScrolling();
        this.initCloseOnClickOutside();

        if (window.matchMedia(`(min-width: ${this.breakpoints['navigation-breakpoint']}px)`).matches) {
            this.belowBreakpoint = false;
        }

        $(window).on('resize', throttle(() => {
            this.handleBodyScrolling();
            this.initCloseOnClickOutside();
            this.closeOnResize();
        }));
    }

    initCloseOnClickOutside() {
        if (window.matchMedia(`(min-width: ${this.breakpoints['navigation-breakpoint']}px)`).matches) {
            this.handleCloseOnClickOutside();

            return;
        }

        document.removeEventListener('click', Header.bodyClickListener);
    }

    handleCloseOnClickOutside() {
        const $toggleSub = $(this.elem).find('.o-navigation__item--main > .o-navigation__toggle-sub');
        $toggleSub.on('change', () => {
            if ($toggleSub.is(':checked')) {
                document.addEventListener('click', Header.bodyClickListener);
                return;
            }
            document.removeEventListener('click', Header.bodyClickListener);
        });
    }

    initBodyScrolling() {
        const mainMenuToggle = document.getElementById('main-menu-toggle');
        const mainMenuItemToggles = this.elem.querySelectorAll('.o-navigation__item--main .o-navigation__toggle-sub');

        if (!window.matchMedia(`(min-width: ${this.breakpoints['navigation-breakpoint']}px)`).matches) {
            mainMenuToggle.addEventListener('change', this.handleScrolling);
            for (const toggle of mainMenuItemToggles) {
                toggle.removeEventListener('change', this.handleScrolling);
            }

            return;
        }

        mainMenuToggle.removeEventListener('change', this.handleScrolling);

        for (const toggle of mainMenuItemToggles) {
            toggle.addEventListener('change', this.handleScrolling);
        }
    }

    handleScrolling(event) {
        if (event.currentTarget.checked) {
            Header.preventScrolling('body');
            return;
        }
        Header.allowScrolling('body');
    }

    handleBodyScrolling() {
        if (window.matchMedia(`(min-width: ${this.breakpoints['navigation-breakpoint']}px)`).matches) {
            Header.allowScrolling('body');
            return;
        }

        // in case the burger navigation is shown, prevent scrolling on active navigation
        if ($('#main-menu-toggle').is(':checked')) {
            Header.preventScrolling('body');
            return;
        }
        Header.allowScrolling('body');
    }

    static preventScrolling(element) {
        $(element).addClass('u-no-scroll');
    }

    static allowScrolling(element) {
        $(element).removeClass('u-no-scroll');
    }

    static bodyClickListener(e) {
        const { target } = e;
        const isNavigation = $(target).closest('.o-header__navigation-wrapper').length
            || document.querySelector('.o-header__navigation-wrapper') === target;

        if (!isNavigation) {
            Header.closeNavigation();
        }
    }

    static closeNavigation() {
        $('.o-navigation__item [type="checkbox"]').prop('checked', false);
    }

    closeOnResize() {
        const currentBreakpointMatch = (window.matchMedia(`(min-width: ${this.breakpoints['navigation-breakpoint']}px)`).matches);
        if (this.belowBreakpoint && currentBreakpointMatch) {
            Header.closeNavigation();
            this.belowBreakpoint = false;
        }

        if (!this.belowBreakpoint && !currentBreakpointMatch) {
            Header.closeNavigation();
            this.belowBreakpoint = true;
        }
    }
}

export default Header;
